define('OutSystems/ReactWidgets/RowCell',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RowCell = void 0;
    var RowCell = (function (_super) {
        tslib_1.__extends(RowCell, _super);
        function RowCell() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        RowCell.prototype.render = function () {
            var rowCellAttributes = {
                className: this.props.style,
            };
            this.fillWithBuiltinProperties(rowCellAttributes);
            return React.createElement("td", tslib_1.__assign({}, rowCellAttributes), this.props.children);
        };
        RowCell = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], RowCell);
        return RowCell;
    }(Widget_1.Widget));
    exports.RowCell = RowCell;
});
//# sourceMappingURL=RowCell.js.map;
